/**
 * Theme entry point for Webpack.
 *
 * Importing the stylesheet here lets Webpack emit a single hashed
 * `site` entry for both the JS and the compiled Tailwind CSS.
 */
// Self-hosted web fonts (Fontsource). Each registers a "… Variable" family
// referenced by the --font-* tokens in styles.css.
import '@fontsource-variable/inter'; // body - --font-sans
import '@fontsource-variable/plus-jakarta-sans'; // headings - --font-display
import '@fontsource-variable/hanken-grotesk'; // accents - --font-hanken
// IBM Plex Mono has no variable build on Fontsource; pull the two weights the
// content style guide needs (code/pre = 400, kbd/emphasis = 500) - --font-mono.
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';

import '../css/styles.css';

import { initHeroSliders } from './slider.js';
import { initFaq } from './faq.js';
import { initMobileMenu } from './mobile-menu.js';
import { initProductConfigurator, initQuantitySteppers, initProductGallery, initCart } from './product.js';
import { initPhotoUpload } from './photo-upload.js';
import { initPrintPreview } from './print-preview.js';
import { initAjaxAddToCart } from './add-to-cart.js';
import { initAccount } from './account.js';

// Theme JavaScript.
function initTheme() {
  initHeroSliders();
  initFaq();
  initMobileMenu();
  initProductConfigurator();
  // Before the uploader: it moves the modal out of the sticky column and binds
  // the sm:preview listener the uploader dispatches into.
  initPrintPreview();
  initPhotoUpload();
  initAjaxAddToCart();
  initQuantitySteppers();
  initCart();
  initProductGallery();
  initAccount();
}

if (document.readyState !== 'loading') {
  initTheme();
} else {
  document.addEventListener('DOMContentLoaded', initTheme);
}
